export enum TemplateType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
